export { EloTwintIcon } from './twint-icon'
